import SectionBasePage from 'components/SectionBasePage';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import {
  ordersIdsSelector,
  ordersEntitiesSelector,
  isLoadingOrdersSelector,
  getOrderAction,
} from 'state/slices/order';
import { Skeleton } from 'UI';

import {
  OrderDisplay,
} from './components';

import {
  LoadingContainer,
} from './style';

interface OrderDetailRouteParams {
  orderId: string
}

const OrderDetailsPage = (): JSX.Element => {
  const dispatch = useDispatch();
  const { orderId: orderUrlId } = useParams<OrderDetailRouteParams>();

  const orderId = useSelector(ordersIdsSelector)
    .find((curOrderId) => `${curOrderId}` === orderUrlId) || '';
  const orderEntities = useSelector(ordersEntitiesSelector);
  const order = orderEntities[orderId];

  const isOrderLoading = useSelector(isLoadingOrdersSelector);

  useEffect(() => {
    if (orderUrlId) {
      dispatch(getOrderAction({
        orderId: orderUrlId,
      }));
    }
  }, [orderUrlId]);

  return (
    <>
      {
        isOrderLoading || !order ? (
          <SectionBasePage>
            <LoadingContainer>
              <Skeleton />
            </LoadingContainer>
          </SectionBasePage>
        ) : (
          <OrderDisplay
            order={order}
          />
        )
      }
    </>
  );
};

export default OrderDetailsPage;
